<span [style.visibility]="showTimer && displaySecond > -1 ? 'visible' : 'hidden'">
  <img src="../../../../assets/images/autosave-timer-icon.png" style="margin-right: 0.5em;height: 35px; width: 40px;" alt="Timer" />
  <span class="autosave">{{caption}} IN: </span>
  <span class="autosave-red">{{displaySecond}} SECONDS</span>
</span>
